// actionTypes.js
export const SET_VALUE = 'SET_VALUE';
export const SET_SANS_EMAIL = 'SET_SANS_EMAIL';
export const SET_EN_ATTENTE_VALIDATION = 'SET_EN_ATTENTE_VALIDATION';
export const SET_STATUT = 'SET_STATUT';
export const SET_TYPE = 'SET_TYPE';
export const SET_COMPTE_OUVERT = 'SET_COMPTE_OUVERT';
export const SET_COURRIER = 'SET_COURRIER';
export const SET_CREE_LE = 'SET_CREE_LE';
export const SET_DERNIERE_SOUSCRIPTION = 'SET_DERNIERE_SOUSCRIPTION';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_SELECTED_OPTIONS = 'SET_SELECTED_OPTIONS';
export const SET_ORDER = 'SET_ORDER';
export const SET_SORT_FIELD = 'SET_SORT_FIELD';
